import dayjs from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

/**
 * Builds the same "last sent" message used in invoice/record-payment.
 * Expects appointment-for-invoice response shape containing `googleReviewRequest` groups.
 */
export function buildReviewLastSentMessage(data, timezone) {
    const allReviewGroups = Array.isArray(data?.googleReviewRequest) ? data.googleReviewRequest : [];
    const firstReviewGroup = allReviewGroups.length > 0 ? allReviewGroups[0] : null;
    const reviewRequests = Array.isArray(firstReviewGroup?.reviewRequest) ? firstReviewGroup.reviewRequest : [];
    const lastRequest = reviewRequests.length > 0 ? reviewRequests[reviewRequests.length - 1] : null;
    const lastSentAt = firstReviewGroup?.lastSentAt;

    if (!firstReviewGroup || reviewRequests.length === 0 || !lastSentAt) return '';

    const isWithin24Hours = lastSentAt && dayjs(lastSentAt).tz(timezone).isAfter(dayjs().tz(timezone).subtract(24, 'hours'));

    const channels = [];
    if (lastRequest?.sms?.sent) channels.push('text');
    if (lastRequest?.email?.sent) channels.push('email');
    if (lastRequest?.notification?.sent) channels.push('app');

    let channelsLabel = '—';
    if (channels.length === 1) {
        channelsLabel = channels[0];
    } else if (channels.length === 2) {
        channelsLabel = `${channels[0]} and ${channels[1]}`;
    } else if (channels.length >= 3) {
        channelsLabel = `${channels[0]}, ${channels[1]} and ${channels[2]}`;
    }

    const formattedDate = dayjs(lastSentAt).tz(timezone).format('DD-MMMM-YYYY');
    const totalRequests = allReviewGroups.length;

    if (isWithin24Hours) {
        return `Last sent via ${channelsLabel} today`;
    }
    if (totalRequests === 1) {
        return `Last sent via ${channelsLabel} on ${formattedDate}`;
    }
    return `${totalRequests} review requests sent previously. Last sent via ${channelsLabel} on ${formattedDate}`;
}
